import axios, { AxiosHeaders } from "axios";
import { getDefaultStore } from "jotai";
import { authTokenAtom } from "../../atoms/user";
export const ARCHITECTON_API_URL = import.meta.env["VITE_ARCHITECTON_API_URL"] ||
    "https://stage.architecton.site";
const axiosInstance = axios.create({
    baseURL: `${ARCHITECTON_API_URL}/api/v2/wallet`,
    headers: {
        "Content-Type": "application/json",
    },
});
axiosInstance.interceptors.request.use((config) => {
    const newConfig = { ...config };
    const store = getDefaultStore();
    const authToken = store.get(authTokenAtom);
    const headers = AxiosHeaders.from(newConfig.headers ?? {});
    if (authToken) {
        headers.set("Authorization", `Bearer ${authToken}`);
    }
    newConfig.headers = headers;
    return newConfig;
}, (error) => Promise.reject(error));
export default axiosInstance;
// cache remover
//# sourceMappingURL=index.js.map